import { jsx as e } from "react/jsx-runtime";
import { n as f } from "./emotion-styled.browser.esm-Br5Hs_hj.js";
function i({
  height: r = 50,
  width: t = 50
}) {
  return /* @__PURE__ */ e(s, { style: { height: r, width: t }, viewBox: "25 25 50 50", children: /* @__PURE__ */ e(
    "circle",
    {
      className: "loader-path",
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none",
      stroke: "#70c542",
      "stroke-width": "2"
    }
  ) });
}
const s = f.svg`

    -webkit-animation: rotate 2s linear infinite;
            animation: rotate 2s linear infinite;
    height: 100%;
    -webkit-transform-origin: center center;
        -ms-transform-origin: center center;
            transform-origin: center center;
    width: 100%;
    
  
  
  .loader-path {
    stroke-dasharray: 150,200;
    stroke-dashoffset: -10;
    -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
            animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }
  
  @-webkit-keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
    }
  }
  
  @keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
    }
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dasharray: 1,200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89,200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89,200;
      stroke-dashoffset: -124;
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1,200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89,200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89,200;
      stroke-dashoffset: -124;
    }
  }
  @-webkit-keyframes color {
    0% {
      stroke: #ffffff;
    }
    40% {
      stroke: #ffffff;
    }
    66% {
      stroke: #ffffff;
    }
    80%, 90% {
      stroke: #ffffff;
    }
  }
  @keyframes color {
    0% {
      stroke: #ffffff;
    }
    40% {
      stroke: #ffffff;
    }
    66% {
      stroke: #ffffff;
    }
    80%, 90% {
      stroke: #ffffff;
    }
  }
`;
export {
  i as C
};
